<template>
    <v-container grid-list-lg>
        <v-layout v-if="painel_lead"   row wrap card>
            <!--Painel de Leads-->
            <v-flex md2 mt-2>
                <span class="title">Painel de Leads</span>
            </v-flex>
            <!--filtro dashboard-->
            <v-flex offset-md8 md2>
                <v-menu content-class="menu-card mt-2 app-content flex"
                        min-width="450px"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        v-model="filtroDash">
                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                        <v-icon color="primary">lnr-funnel</v-icon>
                        <div class="pl-1">Filtrar</div>
                    </v-btn>
                    <v-layout column class="card">
                        <v-layout row wrap>
                            <v-flex mr-3>
                                <v-label>Início</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_ini"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>

                            <v-flex ml-3>
                                <v-label>Fim</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroDash.dash_data_fim"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout mt-3 justify-center>
                            <v-flex xs4>
                                <v-btn class="btn-default" color="dark" outline @click="limparDash">Limpar</v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <v-btn class="btn-default primary" @click="filtrarDash">Filtrar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-menu>
            </v-flex>
            <!--Total de Leads-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-card>
                    <v-progress-circular v-if="total === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                    <v-card-title primary class="title">Total de Leads</v-card-title>
                    <v-card-text class="total lead">{{ total }}</v-card-text>
                    <div class="border" style="bottom: 150px"></div>
                </v-card>
            </v-flex>
            <!--Leads a qualificar e Leads distribuídos-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="qualificar === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Leads a qualificar
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ qualificar }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="distribuidos === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Leads Indicados
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ distribuidos }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Qualificado com agendamento e Negociação concluída-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="qualificado_com_agendamento === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Qualificado com agendamento
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ qualificado_com_agendamento }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="cadastros_manuais === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Leads Cadastro Manual
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ cadastros_manuais }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Em negociacao e Desqualificados-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="negociacao_realizada === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Em negociação
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ negociacao_realizada }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="desqualificado === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Desqualificados
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ desqualificado }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Clientes e Leads convertidos-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="card-info">
                            <v-progress-circular v-if="convertidos === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Leads convertidos
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ convertidos }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="direta === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Vendas Diretas
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ direta }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Desvinculados por SLA-->
            <v-flex d-flex xs12 sm6 md2 lg2 xl2>
                <v-layout row wrap>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="sla === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Desvinculados por SLA
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ sla }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex xl12>
                        <v-card class="card-info">
                            <v-progress-circular v-if="indicada === ''" indeterminate color="primary" class="load-leads" :size="14" :width="2"></v-progress-circular>
                            <v-card-title primary class="info-title">
                                Vendas Indicadas
                            </v-card-title>
                            <v-card-text class="card-value lead info-lead">{{ indicada }}</v-card-text>
                            <div class="border"></div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout card column mt-5 class="table" style="padding: 20px;">
            <!--exportar excel-->
            <v-layout justify-end>
                <v-btn class="btn-default shrink" color="primary" large @click="exportToExcel">
                    Exportar para Excel
                </v-btn>
            </v-layout>
            <!--filtro lista-->
            <v-layout justify-end mr-1>
                <v-menu content-class="menu-card mt-2 app-content flex"
                        min-width="550px"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        full-width
                        v-model="filtroLista">
                    <v-btn slot="activator" class="btn-default" color="dark" large outline>
                        <v-icon color="primary">lnr-funnel</v-icon>
                        <div class="pl-1">Filtrar</div>
                    </v-btn>
                    <v-layout column class="card">
                        <v-layout row wrap>
                            <v-flex mr-3>
                                <v-label>Início</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroLista.data_ini"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>

                            <v-flex ml-3>
                                <v-label>Fim</v-label>
                                <v-text-field ref="textField"
                                              v-model="dadosFiltroLista.data_fim"
                                              flat
                                              solo
                                              validate-on-blur
                                              mask="##/##/####"
                                              return-masked-value
                                              :rules="[rules.date]">
                                </v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap mb-4>
                            <v-flex mr-3>
                                <v-label>Email do lead</v-label>
                                <v-text-field ref="textField" v-model="dadosFiltroLista.email" flat solo hide-details></v-text-field>
                            </v-flex>

                            <v-flex ml-3>
                                <v-label>Login que recebeu</v-label>
                                <v-text-field ref="textField" v-model="dadosFiltroLista.login" flat solo hide-details></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap mt-4>
                            <v-flex mr-3>
                                <v-label>Leads que estão atualmente</v-label>
                                <v-checkbox v-model="dadosFiltroLista.sla" value="sla" label="Desvinculados por SLA" hide-details />
                            </v-flex>

                            <v-flex ml-3>
                                <v-label>Leads que já foram</v-label>
                                <v-checkbox v-model="dadosFiltroLista.convertidos" value="convertidos" label="Convertidos" hide-details />
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap mt-4>
                            <v-flex mr-3>
                                <v-label mb-4>Status</v-label>

                                <v-checkbox v-model="dadosFiltroLista.status" value="qualificar" label="Qualificar" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="desqualificado" label="Desqualificado" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="qualificado_com_agendamento" label="Qualificado com agendamento" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="em_negociacao" label="Em negociação" hide-details />
                            </v-flex>
                            <v-flex ml-3 mt-4>
                                <v-checkbox v-model="dadosFiltroLista.status" value="negociacao_realizada" label="Negociação abandonada" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="qualificado" label="Qualificado" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="cliente_aguardando_pagamento" label="Cliente Aguardando Pagamento" hide-details />

                                <v-checkbox v-model="dadosFiltroLista.status" value="cliente" label="Cliente" hide-details />
                            </v-flex>
                        </v-layout>

                        <v-layout row wrap mt-4>
                            <v-flex>
                                <v-label>Nas Cidades</v-label>
                                <autocomplete
                                        placeholder="Selecione as cidades"
                                        url="/admin/cidades/autocomplete"
                                        :items="cidades"
                                        v-model="dadosFiltroLista.cidades"
                                        item-text="descricao"
                                        item-value="id_cidade"
                                        max-items="10"
                                        multiple chips>
                                </autocomplete>
                            </v-flex>
                        </v-layout>

                        <v-layout mt-3 justify-center>
                            <v-flex xs4>
                                <v-btn class="btn-default" color="dark" outline @click="limparLista">Limpar</v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <v-btn class="btn-default primary" @click="filtrarLista">Filtrar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-menu>
            </v-layout>
            <!--lista-->
            <data-table ref="table" url="/admin/leads/historico"
                        :filter="dtFiltro"
                        :headers="headers"
                        :params="params"
                        item-key="id_lead"
                        sort-by="data_hora_criacao"
                        :descending="true">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.data_hora_criacao | dia_mes_ano_hora_min }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.usuario ? `${item.usuario.nome} (${item.usuario.login})` : 'Lead sem vendedor' }}</td>
                    <td>{{ getStatus(item.status).text }}</td>
                    <td>
                        <a href="javascript:" @click="ver(item)"><b>Ver detalhes</b></a>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>

/**
     * @param {{qtd:string}} data
     */

import Rules from '../plugins/validation'
import DataTable from '../components/DataTable'
import moment from 'moment'
import { error, sleep } from '../plugins/helpers'
import { LeadStatus } from '../constantes'

export default {
  components: { DataTable },
  data: () => ({
    total: '',
    qualificar: '',
    distribuidos: '',
    qualificado_com_agendamento: '',
    negociacao_realizada: '',
    em_negociacao: '',
    cadastros_manuais: '',
    desqualificado: '',
    cliente_aguardando_pagamento: '',
    cliente: '',
    convertidos: '',
    sla: '',
    direta: '',
    indicada: '',
    checkBox: true,
    cidades: [],
    headers: [
      { text: 'Data Criação', value: 'data_hora_criacao' },
      { text: 'E-mail', value: 'email' },
      { text: 'Vendedor', value: 'login' },
      { text: 'Status', value: 'status' },
      { text: '', value: '' }
    ],
    filtroLista: false,
    dadosFiltroLista: {
      email: '',
      data_ini: '',
      data_fim: '',
      login: '',
      sla: false,
      convertidos: false,
      status: [],
      status_qualificar: false,
      status_desqualificado: false,
      status_qualificado_com_agendamento: false,
      status_em_negociacao: false,
      status_negociacao_realizada: false,
      status_qualificado: false,
      status_cliente_aguardando_pagamento: false,
      status_cliente: false,
      cep_ini: '',
      cep_fim: '',
      cidades: []
    },
    filtroDash: false,
    dadosFiltroDash: {
      dash_data_ini: '',
      dash_data_fim: ''
    },
    dtFiltro: {},
    dash_data_ini: '',
    dash_data_fim: '',
    id_usuario: '',
    id_unidade_negocio: '',
    painel_lead: false,
    listaStatusLead: [
      { text: 'Qualificar', id: LeadStatus.qualificar.status },
      { text: LeadStatus.desqualificado.desc, id: LeadStatus.desqualificado.status },
      { text: LeadStatus.qualificado.desc, id: LeadStatus.qualificado.status },
      { text: LeadStatus.qualificado_agendamento.desc, id: LeadStatus.qualificado_agendamento.status },
      { text: LeadStatus.em_negociacao.desc, id: LeadStatus.em_negociacao.status },
      { text: LeadStatus.negociacao_realizada.desc, id: LeadStatus.negociacao_realizada.status },
      { text: LeadStatus.cliente_aguardando_pagamento.desc, id: LeadStatus.cliente_aguardando_pagamento.status },
      { text: LeadStatus.cliente.desc, id: LeadStatus.cliente.status }
    ]
  }),
  computed: {
    rules: () => Rules,
    params () {
      return {
        id_usuario: this.id_usuario,
        id_unidade_negocio: this.id_unidade_negocio,
        pagination: {
          descending: true,
          sortBy: 'email'
        }
      }
    }
  },
  filters: {
    dia_mes_ano_hora_min: function (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  watch: {
    filtroDash (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    },
    filtroLista (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    getStatus (status) {
      return this.listaStatusLead.find((s) => s.id === status) || ''
    },
    filtrarDash () {
      this.filtroDash = false

      // total
      this.getTotal(this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getCadastrosManuais(this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)

      // leads por status
      this.getByStatus('qualificar', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('qualificado_com_agendamento', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('negociacao_realizada', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('em_negociacao', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('desqualificado', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('cliente_aguardando_pagamento', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getByStatus('cliente', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)

      // sla
      this.getSla(this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)

      // Quantidade de Leads Convertidos
      this.getTeveStatus('cliente', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)

      // Distribuidos
      this.getDistribuidos(this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)

      // Vendas
      this.getVendaTipo('direta', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
      this.getVendaTipo('indicada', this.dadosFiltroDash.dash_data_ini, this.dadosFiltroDash.dash_data_fim)
    },
    limparDash () {
      this.dadosFiltroDash = {
        dash_data_ini: [],
        dash_data_fim: []
      }
      this.filtrarDash()
    },
    filtrarLista () {
      this.filtroLista = false
      this.dtFiltro = { ...this.dadosFiltroLista }
    },
    limparLista () {
      this.dadosFiltroLista = {
        email: '',
        data_ini: '',
        data_fim: '',
        login: '',
        sla: false,
        convertidos: false,
        status: [],
        status_qualificar: false,
        status_desqualificado: false,
        status_qualificado_com_agendamento: false,
        status_em_negociacao: false,
        status_negociacao_realizada: false,
        status_qualificado: false,
        status_cliente_aguardando_pagamento: false,
        status_cliente: false,
        cep_ini: '',
        cep_fim: ''
      }
      this.filtrarLista()
    },
    ver (item) {
      this.$router.push({ name: 'detalhe_historico_leads', params: { id_lead: `${item.id_lead}` } })
    },
    getTotal (ini, fim) {
      this.$http.get('/admin/leads/total', {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this.total = r.data || 0
      }).catch(this.fail)
    },
    getCadastrosManuais (ini, fim) {
      this.$http.get('/admin/leads/cadastrosmanuais', {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this.cadastros_manuais = r.data || 0
      }).catch(this.fail)
    },
    getByStatus (status, ini, fim) {
      this.$http.get('admin/leads/status/' + status, {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this[status] = r.data.qtd || 0
      }).catch(this.fail)
    },
    getSla (ini, fim) {
      this.$http.get('/admin/leads/sla', {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          count: true,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this.sla = r.data.qtd || 0
      }).catch(this.fail)
    },
    getTeveStatus (status, ini, fim) {
      this.$http.get('/admin/leads/tevestatus/' + status, {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          count: true,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this.convertidos = r.data.qtd || 0
      }).catch(this.fail)
    },
    getDistribuidos (ini, fim) {
      this.$http.get('/admin/leads/distribuidos', {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this.distribuidos = r.data || 0
      }).catch(this.fail)
    },
    getVendaTipo (tipo, ini, fim) {
      this.$http.get('/admin/leads/tipovenda/' + tipo, {
        params: {
          id_unidade_negocio: this.id_unidade_negocio,
          id_usuario: this.id_usuario,
          ini: ini,
          fim: fim
        },
        options: { silent: true }
      }).then((r) => {
        this[tipo] = r.data.qtd || 0
      }).catch(this.fail)
    },
    exportToExcel () {
      let params = {}
      params.id_unidade_negocio = this.id_unidade_negocio
      params.filtros = this.dadosFiltroLista

      this.$http.get('/admin/leads/export/historico', {
        responseType: 'blob',
        params
      }).then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'export.xlsx')
        document.body.appendChild(link)
        link.click()
      })
        .catch(err => {
          error(err, 'Não foi possível recuperar as informações.')
        })
    }
  },
  mounted () {
    this.id_usuario = this.$session.get('id_usuario')
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
    this.painel_lead = this.$session.get('painel_lead')

    if (this.painel_lead) {
      // total
      this.getTotal('', '')
      this.getCadastrosManuais('', '')

      // leads por status
      this.getByStatus('qualificar', '', '')
      this.getByStatus('qualificado_com_agendamento', '', '')
      this.getByStatus('negociacao_realizada', '', '')
      this.getByStatus('em_negociacao', '', '')
      this.getByStatus('desqualificado', '', '')
      this.getByStatus('cliente', '', '')

      // sla
      this.getSla('', '')

      // Quantidade de Leads Convertidos
      this.getTeveStatus('cliente', '', '')

      // Distribuidos
      this.getDistribuidos('', '')

      // Vendas
      this.getVendaTipo('direta', '', '')
      this.getVendaTipo('indicada', '', '')
    }
  }
}

</script>

<style scoped>
    .card-info {
        height: 120px;
        position: relative;
    }

    .card-value {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .lead {
        position: absolute;
        bottom: 0;
        font-weight: bold;
    }

    .total {
        font-size: 30px;
        text-align: center;
        bottom: 60px;
    }

    .info-lead {
        font-size: 20px;
        text-align: center;
    }

    .info-title {
        font-weight: bold;
        color: #757575;
    }

    .title {
        font-size: 18px !important;
        color: #757575;
    }

    .border {
        border: 1px solid #9E9E9E;
        width: 30px;
        margin: 0 auto;
        height: 0;
        left: 0;
        right: 0;
        position: absolute;
        bottom: 55px;
    }

    .load-leads {
        float: right;
        padding: 5px;
        opacity: 0.7;
    }
</style>
